"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Tariff_1 = tslib_1.__importDefault(require("./Tariff"));
const OfferWithEstimatesProduct_1 = tslib_1.__importDefault(require("./OfferWithEstimatesProduct"));
class ConnectionWithTariffs extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: base_models_1.EnergyType.ELECTRICITY,
        description: 'Whether this connection is a gas or electricity connection',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.EnergyType)),
    tslib_1.__metadata("design:type", String)
], ConnectionWithTariffs.prototype, "connectionType", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '8716879000004',
        description: `Ean of the connection, optional for use when this connection doesn't have an EAN yet`,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ConnectionWithTariffs.prototype, "connectEan", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => Tariff_1.default),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Tariff_1.default)
], ConnectionWithTariffs.prototype, "tariffs", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => OfferWithEstimatesProduct_1.default),
    tslib_1.__metadata("design:type", OfferWithEstimatesProduct_1.default)
], ConnectionWithTariffs.prototype, "product", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/\d{4}-\d{2}-\d{2}/),
    (0, base_models_1.Docs)({
        example: '2022-12-01',
        description: `The tariff date as passed along to AoM.`,
    }),
    tslib_1.__metadata("design:type", String)
], ConnectionWithTariffs.prototype, "tariffDate", void 0);
exports.default = ConnectionWithTariffs;
